import {
  Button,
  Divider,
  FormControl,
  Grid,
  InputAdornment,
  Paper,
  TextField,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useEffect, useState } from "react";
import { FID_LOGO } from "../DrawerAppBar";
import { Link, useNavigate } from "react-router-dom";
import AuthService from "../../../service/AuthService";
import useToast from "../../../hooks/useToast";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import useConfirm from "../../../hooks/useConfirm";
import useNotification from "../../../hooks/useNotification";
import { TYPE_NOTIFICATION } from "../shares/NotificationBull";
import { useQuery } from "../../../hooks/useQuery";

const ResetPassword = () => {
  const url = useQuery();
  const { Toast, showToast } = useToast();
  const [loading, setloading] = useState(false);
  const [submited, setSubmitted] = useState(false);
  const [authData, setAuthData] = useState({
    token: url.get("token"),
    uuid: url.get("ref"),
    password: "",
    confirmer: "",
  });
  const [message, setMessage] = useState("");
  const { DialogComponent, openConfirmDialog } = useConfirm();
  const { NotificationComponent, showNotification } = useNotification();
  const navigate = useNavigate();
  const [formError, setFormError] = useState({
    passwordError: null,
    confirmError: null,
  });

  const isSubmitted = () => {
    return submited;
  };

  const handleSubmit = () => {
    setSubmitted(true);
    setloading(true);
    const isValid = checkDataValidation(authData);
    if (isValid) {
      AuthService.changePassword(authData)
        .then((res) => {
          if (res && res.success) {
            setFormError({ mailError: null, passwordError: null });
            showNotification(
              "Mot de passe modifié avec succès",
              "Votre mot de passe est modifié avec succès, vous pouvez revenir à la page d'authentification",
              TYPE_NOTIFICATION.SUCCESS,
              () => {
                navigate("/login");
              },
              "Revenir à la page d'authentification"
            );
          } else {
            setMessage(res.message);
            showToast(TYPE_NOTIFICATION.ERROR, res.message);
          }
        })
        .finally((res) => {
          setloading(false);
        });
    } else {
      setloading(false);
    }
  };

  const checkDataValidation = (authData) => {
    setFormError({
      passwordError: authData.password
        ? authData.password.length >= 6
          ? null
          : "Le mot de passe doit contenir au moins 6 caractères"
        : "Le champ mot de passe est obligatoire",
      confirmError: authData.confirmer
        ? authData.password === authData.confirmer
          ? null
          : "Les mots de passe ne correspondent pas"
        : "Le champ confirmer mot de passe est obligatoire",
    });
    return Object.values(formError).every((error) => error === null);
  };

  useEffect(() => {
    if (AuthService.isConnected()) {
      navigate("/");
    }
    checkDataValidation(authData);
  }, []);

  useEffect(() => {
    if (authData.confirmer || authData.password) {
      checkDataValidation(authData);
    }
  }, [authData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAuthData({ ...authData, [name]: value });
  };
  return (
    <>
      <NotificationComponent />
      <DialogComponent />
      <Toast />
      <Grid
        item
        md={4}
        xs={10}
        sm={6}
        lg={4}
        xl={3}
        display={"flex"}
        flexDirection={"column"}
        m={3}
      >
        <Paper sx={{ p: 3 }}>
          <Grid item xs={12} display={"flex"} justifyContent="center">
            {FID_LOGO}
          </Grid>
          <h3>Modifier mot de passe</h3>
          <Grid
            container
            display={"flex"}
            flexDirection={"column"}
            justifyContent="center"
            alignItems="center"
          >
            <Grid container display={"flex"} flexDirection={"column"}>
              <FormControl fullWidth sx={{ mt: 2 }}>
                <label>Nouveau mot de passe *</label>
                <TextField
                  id="password"
                  name="password"
                  type="password"
                  size="small"
                  placeholder="Mot de passe"
                  fullWidth
                  onChange={(e) => handleChange(e)}
                  value={authData.password}
                  error={formError.passwordError && isSubmitted()}
                  helperText={
                    formError.passwordError && isSubmitted()
                      ? formError.passwordError
                      : null
                  }
                  aria-describedby="pwd_helper"
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <LockOutlinedIcon />
                        </InputAdornment>
                      ),
                    },
                  }}
                />
                {/* <FormHelperText id="pwd_helper">{message}</FormHelperText> */}
              </FormControl>
              <FormControl fullWidth sx={{ mt: 2 }}>
                <label>Confirmer *</label>
                <TextField
                  id="confirmer"
                  name="confirmer"
                  type="password"
                  size="small"
                  placeholder="Confirmer mot de passe"
                  fullWidth
                  onChange={(e) => handleChange(e)}
                  value={authData.confirmer}
                  error={formError.confirmError && isSubmitted()}
                  helperText={
                    formError.confirmError && isSubmitted()
                      ? formError.confirmError
                      : null
                  }
                  aria-describedby="conf_pwd_helper"
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <LockOutlinedIcon />
                        </InputAdornment>
                      ),
                    },
                  }}
                />
              </FormControl>
            </Grid>
            <Grid
              item
              display={"flex"}
              justifyContent="center"
              alignItems="center"
              pt={5}
              width={"100%"}
            >
              <LoadingButton
                fullWidth
                loading={loading}
                variant="contained"
                type="submit"
                onClick={handleSubmit}
              >
                Mettre à jour
              </LoadingButton>
            </Grid>
            <Grid
              item
              xs={12}
              mt={2}
              width={"100%"}
              justifyContent={"center"}
              display={"flex"}
              flexDirection={"column"}
            >
              <Divider variant="middle" sx={{ mb: 3 }} />
            </Grid>
            <Grid item xs={12} width={"100%"}>
              <Link to="/login" color="secondary" underline="hover">
                <Button fullWidth>Revenir à la page d'authentificaiton</Button>
              </Link>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </>
  );
};

export default ResetPassword;
